export default "__VITE_ASSET__2GZYtJlT__"